// extracted by mini-css-extract-plugin
export default {"sigin":"HeaderSignIn_sigin__F75MJ","signin__wrapper":"HeaderSignIn_signin__wrapper__m8Ygc"};